// Libraries
import React from 'react';
import {Link} from 'gatsby';
import {StaticImage} from 'gatsby-plugin-image';
import {useTranslation} from 'react-i18next';
// Icons
import Phone from '@Icons/Phone';
import Mail from '@Icons/Mail';
import Location from '@Icons/Location';
// Components
import Container from '@Components/Container/Container';
// Types
import {Tag} from '@Types/tags';
// Styles
import * as styles from './Footer.module.scss';
import TimelineItem from '@Components/Timeline/components/TimelineItem/TimelineItem';
import classNames from 'classnames';

const Footer = () => {
	const {t, i18n} = useTranslation();

	return (
		<Container as={Tag.Footer} classes={styles.wrapper}>
			<Link to='/'>
				<StaticImage
					src='../../../../assets/icons/footer-logo.svg'
					alt='mbm energy'
					loading='lazy'
					placeholder='blurred'
					formats={['auto', 'webp']}
					objectFit='contain'
				/>
			</Link>

			<div className={styles.links}>
				<div className={styles.linksItem}>
					<h4 className={styles.title}>{t('footer.info.title')}</h4>
					<Link className={styles.text} to={t('routes.policy.link')}>
						{t('routes.policy.text')}
					</Link>
				</div>
				<div className={styles.linksItem}>
					<h4 className={styles.title}>Kontakt</h4>
					<div className={styles.contact}>
						<TimelineItem
							classes={styles.contactEl}
							link='tel:+48577785664'
							title='+48 577 785 664'
							icon={<Phone />}
						/>
						<TimelineItem
							classes={styles.contactEl}
							link='mailto:biuro@mbm-energy.pl'
							title='biuro@mbm-energy.pl'
							icon={<Mail />}
						/>
						<TimelineItem
							classes={styles.contactEl}
							link='https://g.co/kgs/grsWPm9'
							title={
								<>
									ul. Nieszawska 1A/6,
									<br />
									61-021 Poznań
								</>
							}
							icon={<Location />}
						/>
					</div>
				</div>
			</div>

			<p className={styles.bottom}>
				<small>Copyright &copy; 2024 All rights reserved</small>
				<br />
				<small>
					Designed & made by:{' '}
					<a
						href='https://www.innovate-ts.com'
						target='_blank'
						rel='noopener noreferrer'>
						ITS
					</a>
				</small>
			</p>
		</Container>
	);
};

export default Footer;
